"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parallelPromise = void 0;
/**
 * Runs  promises in parallel. Accepts an array of promises.
 *
 * .then(values) - called when evrth has been called in parallel and without ANY error.
 *
 * .catch(errors) - called when any of promises has been resolved with error.
 * [errors] - object with rejected errors.
 * */
function parallelPromise(promises) {
    let errorsArray = [];
    let errorsObject = {};
    let ready = Promise.resolve();
    promises.forEach((promise) => {
        ready = ready
            .then(() => promise)
            .catch((error) => {
            errorsArray.push(error);
        });
    });
    return ready.then(() => __awaiter(this, void 0, void 0, function* () {
        // remove empty error entries
        errorsArray = errorsArray.filter((err) => !!err);
        errorsArray.forEach((err) => {
            errorsObject = Object.assign(Object.assign({}, errorsObject), (err || {}));
        });
        if (Object.keys(errorsArray).length > 0) {
            throw errorsObject;
        }
    }));
}
exports.parallelPromise = parallelPromise;
//# sourceMappingURL=parallelPromise.js.map